import { Shuffle, CheckCircle2 } from 'lucide-react';

interface RandomNextToggleProps {
    /** Estado atual do toggle */
    isRandom: boolean;
    /** Callback ao alternar */
    onChange: (next: boolean) => void;
    /** Opcional — desabilita o botão (ex.: enquanto está salvando) */
    disabled?: boolean;
}

/**
 * Toggle "Próximo node aleatório" — quando ativo e o node atual tiver mais de
 * uma conexão de saída, o executor sorteia UMA dessas conexões em vez de
 * disparar todas em paralelo.
 *
 * Aplica por node, não em cascata: para o sorteio acontecer em mais de um
 * ponto do flow, o usuário precisa ativar o toggle em cada node de bifurcação.
 *
 * Backend: `chatmeta_nodes.is_random` (já lido por `flow_executor._continue_to_next`).
 */
export default function RandomNextToggle({ isRandom, onChange, disabled }: RandomNextToggleProps) {
    return (
        <button
            type="button"
            onClick={() => onChange(!isRandom)}
            disabled={disabled}
            className={`w-full flex items-center gap-3 border-2 border-dashed rounded-lg px-4 py-3 transition-all text-left
                ${isRandom
                    ? 'border-orange-300 bg-orange-50 text-orange-600'
                    : 'border-gray-300 hover:border-orange-400 hover:bg-orange-50 text-gray-500 cursor-pointer'
                }
                ${disabled ? 'opacity-60 cursor-not-allowed' : ''}
            `}
        >
            <Shuffle className="w-4 h-4 flex-shrink-0" />
            <div>
                <p className="text-sm font-medium">Próximo node aleatório</p>
                <p className="text-xs opacity-70">
                    Sorteia um dos nodes conectados a este (só funciona se houver 2+ conexões)
                </p>
            </div>
            {isRandom && <CheckCircle2 className="w-4 h-4 ml-auto flex-shrink-0 text-orange-500" />}
        </button>
    );
}
